import { keyDatesArrayToObject } from '../services/keyDatesMapper';

export function getClosingDisclosureRows(loanDetail) {
  const timeline = loanDetail?.disclosureDeliveryTimeline ?? loanDetail?.DisclosureDeliveryTimeline;
  const fromTimeline = timeline?.closingDisclosureRows ?? timeline?.ClosingDisclosureRows;
  const raw = fromTimeline ?? loanDetail?.closingDisclosureRows ?? loanDetail?.ClosingDisclosureRows ?? [];
  return Array.isArray(raw) ? raw : [];
}

/**
 * True when the initial Closing Disclosure has been signed by all borrowers.
 * Falls back to disclosure rows and docOrder when keyDates omits closingDisclosureSignedDate.
 */
export function isInitialClosingDisclosureSigned(loanDetail) {
  const keyDates = keyDatesArrayToObject(loanDetail?.keyDates);
  if (keyDates.closingDisclosureSignedDate) return true;

  const rows = getClosingDisclosureRows(loanDetail);
  if (rows.length > 0) {
    const byDelivery = new Map();
    for (const row of rows) {
      const id = row.deliveryId ?? row.DeliveryId ?? `row-${byDelivery.size}`;
      if (!byDelivery.has(id)) byDelivery.set(id, []);
      byDelivery.get(id).push(row);
    }
    let initialGroup = null;
    let initialTime = Infinity;
    for (const group of byDelivery.values()) {
      const times = group
        .map((r) => new Date(r.createdAt ?? r.sentAt ?? r.CreatedAt ?? r.SentAt ?? 0).getTime())
        .filter(Number.isFinite);
      const t = times.length ? Math.min(...times) : Infinity;
      if (t < initialTime) {
        initialTime = t;
        initialGroup = group;
      }
    }
    if (initialGroup?.length > 0 && initialGroup.every((r) => r.signedAt ?? r.SignedAt)) {
      return true;
    }
  }

  const docOrderFields = [
    ...(loanDetail?.docOrder?.sections ?? []).flatMap((s) => s.fields ?? []),
    ...(loanDetail?.docOrder?.fields ?? []),
  ];
  return docOrderFields.some(
    (f) => f.key === 'initialClosingDisclosureAllBorrowersSigned' && f.value === 'Yes',
  );
}

/** Clear to close: key date and/or UW decision. */
export function isClearToCloseForDocOrder(loanDetail) {
  const keyDates = keyDatesArrayToObject(loanDetail?.keyDates);
  if (keyDates.clearedToCloseDate) return true;
  return loanDetail?.loan?.underwriterDecision === 'ClearToClose';
}

/** Mirrors LoanDetailPage Doc Order tab visibility. */
export function shouldShowDocOrderTab(loanDetail) {
  return (
    loanDetail?.docOrder != null
    && isClearToCloseForDocOrder(loanDetail)
    && isInitialClosingDisclosureSigned(loanDetail)
  );
}
